/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PublicTestSubsourceConnectionV2Dto = {
    /**
     * The type of subsource to test
     */
    type: PublicTestSubsourceConnectionV2Dto.type;
};

export namespace PublicTestSubsourceConnectionV2Dto {

    /**
     * The type of subsource to test
     */
    export enum type {
        ATHENA = 'ATHENA',
        BIGQUERY = 'BIGQUERY',
        REDSHIFT = 'REDSHIFT',
        SNOWFLAKE = 'SNOWFLAKE',
        DATABRICKS = 'DATABRICKS',
        DATABRICKS_JOBS = 'DATABRICKS_JOBS',
        MSSQL = 'MSSQL',
        MYSQL = 'MYSQL',
        POSTGRESQL = 'POSTGRESQL',
        ORACLE = 'ORACLE',
        SYNAPSE = 'SYNAPSE',
        LOOKER = 'LOOKER',
        TABLEAU = 'TABLEAU',
        QUICKSIGHT = 'QUICKSIGHT',
        MICROSTRATEGY = 'MICROSTRATEGY',
        QLIK = 'QLIK',
        ADF = 'ADF',
        AIRFLOW = 'AIRFLOW',
        MWAA = 'MWAA',
        DBT = 'DBT',
        DBTCLOUD = 'DBTCLOUD',
        FIVETRAN = 'FIVETRAN',
        POWER_BI = 'POWER_BI',
        DECLARATIVE = 'DECLARATIVE',
    }


}
